module.exports = __webpack_public_path__ + "img/ntels_logo.b6f9d8b6.png";